(() => {
  const ATTR = 'data-card-media-slider-initialized';

  function updateProgress(root) {
    const track = root.querySelector('[data-card-media-slider-track]');
    const fill = root.querySelector('[data-card-media-slider-fill]');
    if (!track || !fill) return;

    const slideCount = parseInt(root.getAttribute('data-slider-count'), 10) || 1;
    if (slideCount <= 1) return;

    const w = track.clientWidth;
    if (!w) return;

    const idx = Math.min(
      slideCount - 1,
      Math.max(0, Math.round(track.scrollLeft / w))
    );

    fill.style.setProperty('--slider-index', String(idx));
    fill.style.setProperty('--slider-count', String(slideCount));
  }

  function bind(root) {
    const track = root.querySelector('[data-card-media-slider-track]');
    if (!track || track.getAttribute(ATTR) === 'true') return;

    const slideCount = parseInt(root.getAttribute('data-slider-count'), 10) || 0;
    if (slideCount <= 1) return;

    track.setAttribute(ATTR, 'true');

    const handler = () => updateProgress(root);
    track.addEventListener('scroll', handler, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(handler).observe(track);
    }

    handler();
  }

  function initAll() {
    document.querySelectorAll('[data-card-media-slider]').forEach(bind);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  if (typeof MutationObserver !== 'undefined') {
    const observeRoot = (root) => {
      let t;
      new MutationObserver(() => {
        clearTimeout(t);
        t = setTimeout(initAll, 10);
      }).observe(root, { childList: true, subtree: true });
    };

    const grid = document.getElementById('ProductGridContainer');
    if (grid) observeRoot(grid);

    document.querySelectorAll('[id^="collection-"]').forEach(observeRoot);
  }
})();
